import { DocumentNode, useMutation } from "@apollo/client";

import { GqlMapEditorFeatureUpdateInput, gql } from "~/__generated__";

import { MapEditorGetAllLayerFeaturesDocument } from "./useMapEditorGetAllLayerFeatures.generated";

const MAP_EDITOR_FEATURE_UPDATE = gql(`
    mutation MapEditorFeatureUpdate($input: GqlMapEditorFeatureUpdateInput!) {
        mapEditorFeatureUpdate(input: $input) {
            type
            geometry
            properties
        }
    }
`);

export default function useMapEditorFeatureUpdate(featureMutateRefetchQueries: DocumentNode[]) {
    const [featureUpdate, { data, loading, error }] = useMutation(MAP_EDITOR_FEATURE_UPDATE, {
        refetchQueries: [MapEditorGetAllLayerFeaturesDocument, ...featureMutateRefetchQueries],
    });

    return {
        featureUpdate: (input: GqlMapEditorFeatureUpdateInput) =>
            featureUpdate({
                variables: { input },
            }),
        loading,
        error,
        data: data?.mapEditorFeatureUpdate,
    };
}
